<script lang="ts" setup>
    const props = defineProps<{ formConfig: StickyContactFormStoryblok['FormConfig'] }>();
    const emit = defineEmits<{ (e: 'toggle', config: string): void }>();
</script>

<template>
    <div class="sticky-contact-choice">
        <div class="sticky-contact-choice__headline">{{ $t('stickyContactForm.choice.headline') }}</div>

        <button
            v-for="(config, index) in props.formConfig"
            :key="`${config}-${index}`"
            class="sticky-contact-choice__button"
            :class="`sticky-contact-choice__button--${config || 'default'}`"
            @click="emit('toggle', config)"
        >
            <!-- TODO: when chatbot is active, make icon name conditional again: `:name="config === 'chatbot' ? 'lucide:headset' : 'lucide:message-circle'"`-->
            <Icon
                class="sticky-contact-choice__icon"
                :name="'lucide:message-circle'"
                size="32px"
                mode="svg"
            />

            <span class="sticky-contact-choice__content">
                <strong>{{ $t(`stickyContactForm.choice.${config}.title`) }}</strong>
                <span>{{ $t(`stickyContactForm.choice.${config}.text`) }}</span>
            </span>
        </button>
    </div>
</template>

<style lang="scss" scoped>
    .sticky-contact-choice {
        display: flex;
        flex-direction: column;
        gap: $spacing--05;

        &__headline {
            margin-bottom: $spacing--05;
            color: $black;
            font-size: $font-m;
            font-weight: 700;
        }

        &__button {
            display: flex;
            align-items: center;
            gap: $spacing;
            width: 100%;
            margin-bottom: $spacing--05;
            padding: $spacing;
            border: 0;
            border-radius: 8px;
            background: linear-gradient(110deg, #c7e9e8 0%, #e8e7c8 100%);
            color: $black;
            text-align: left;
            cursor: pointer;

            &:hover,
            &:focus-visible {
                opacity: 0.85;
            }

            &:focus-visible {
                outline: 2px solid $color-focus;
                outline-offset: 2px;
            }
        }

        &__icon {
            flex-shrink: 0;
        }

        &__content {
            display: flex;
            flex-direction: column;
            line-height: 1.2;

            strong {
                font-weight: 700;
            }

            span {
                font-size: $font-s;
            }
        }
    }

    :deep(.sticky-contact-choice__icon *) {
        stroke-width: 2;
    }
</style>
